import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "sonner";
import { markWriteBackSuccess } from "@/api/writeBackManagement";

export function useMarkWriteBackSuccess() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (encounterId: string) => markWriteBackSuccess(encounterId),
    onSuccess: (result) => {
      toast.success(result.message);
      queryClient.invalidateQueries({ queryKey: ["errored-write-backs"] });
      queryClient.invalidateQueries({ queryKey: ["encounter-write-backs"] });
    },
    onError: (error) => {
      toast.error(`Failed to mark as succeeded: ${error.message}`);
    },
  });
}
